import { gate } from 'hub-http/gates';
export const SubscriptionGroups = 'subscriptions:groupSettings';
export const Pagination = 'Forms:Pagination';
export const CampaignBusinessUnit = 'campaign-business-unit';
export const SubmissionsExportName = 'Submissions:ExportName';
export const Helpdesk = 'Conversations:HelpDesk';
export const LimitedTicketFunctionInInbox = 'HelpDesk:LimitedTicketFunctionInInbox';
export const RemoveATCFromForms = 'HelpDesk:LimitedTicketFunctionInInbox:RemoveATCFromForms';
export const OverridePaymentPermissions = 'Forms:OverridePaymentPermissions';
export const BusinessUnitUsers = 'business-units:business-unit-users';
export const ShareEmbedV3 = 'Forms:ShareEmbedV3';
export const SunsettingPopupCreation = 'Forms:SunsettingPopupCreation';
export const NewEditorAccess = 'Forms:NewEditorAccess';

//#forms-ccp, potential rollout planned in 2024 Q3
export const AdConsentProperties = 'Forms:AdConsentProperties';
export const BusinessUnitPicker = 'navigation:businessUnitPicker';
export const MarketingHome = 'MO:MarketingHome';
export const DefaultForm = gate('VisExpEditor:DefaultForm');
export const DataEnrichmentBeta = gate('DataEnrichment:PublicBeta');
export const MarketingAnalyticsBeta = 'RL:MarketingAnalyticsPrivateBeta';
export const PLGEmptyState = gate('VisExpEditor:PLGOnboarding');
export const FormTemplates = gate('VisExpEditor:Templates');
export const HTMLSanitizion = gate('Forms:HtmlSanitization');
export const InlineHtmlSanitization = gate('Forms:InlineHtmlSanitization');
export const LeadGenerationExperiment = gate('MO:DiscoveryCardsExperiment');
export const NewEditorTicketProperties = gate('VisExpEditor:TicketProperties');
export const RedirectToNewDashboardApp = gate('Forms:RedirectToNewDashboardApp');
export const CopilotCreateForm = gate('VisExpEditor:CopilotCreateForm');